import React, { useState, useRef } from 'react';
import { supabase } from '../../lib/supabase';
import { Upload, X, Image } from 'lucide-react';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;

const FileUpload = ({ currentUrl, onUpload, label = 'Logo', folder = 'companies' }) => {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentUrl || '');
  const fileRef = useRef();

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      const ext = file.name.split('.').pop();
      const fileName = `${folder}/${Date.now()}.${ext}`;

      const { error } = await supabase.storage.from('logos').upload(fileName, file, {
        cacheControl: '3600',
        upsert: false
      });

      if (error) throw error;

      const publicUrl = `${SUPABASE_URL}/storage/v1/object/public/logos/${fileName}`;
      setPreview(publicUrl);
      onUpload(publicUrl);
    } catch (err) {
      console.error('Upload error:', err);
      alert('Erro ao fazer upload: ' + (err.message || 'Tente novamente'));
    } finally {
      setUploading(false);
    }
  };

  const handleClear = () => {
    setPreview('');
    onUpload('');
    if (fileRef.current) fileRef.current.value = '';
  };

  return (
    <div>
      <label className="block text-gray-300 text-xs font-semibold uppercase tracking-wide mb-2">{label}</label>
      <div className="flex items-center space-x-4">
        {/* Preview */}
        <div className="w-16 h-16 bg-gray-800 border border-gray-700 rounded-xl flex items-center justify-center overflow-hidden flex-shrink-0">
          {preview ? (
            <img src={preview} alt="Preview" className="w-full h-full object-contain p-1"
              onError={(e) => { e.target.style.display = 'none'; }} />
          ) : (
            <Image className="text-gray-600" size={24} />
          )}
        </div>

        <div className="flex-1 space-y-2">
          {/* URL input */}
          <input
            value={preview}
            onChange={(e) => { setPreview(e.target.value); onUpload(e.target.value); }}
            placeholder="URL da imagem ou faça upload"
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-lime-400"
          />

          {/* Upload button */}
          <div className="flex items-center space-x-2">
            <label className={`inline-flex items-center space-x-2 px-3 py-1.5 rounded-lg text-xs font-semibold cursor-pointer transition-colors ${uploading ? 'bg-gray-700 text-gray-400' : 'bg-lime-400/20 text-lime-400 hover:bg-lime-400/30'}`}>
              <Upload size={14} />
              <span>{uploading ? 'Enviando...' : 'Upload'}</span>
              <input ref={fileRef} type="file" accept="image/*" onChange={handleUpload} disabled={uploading} className="hidden" />
            </label>
            {preview && (
              <button onClick={handleClear} className="p-1.5 text-gray-500 hover:text-red-400"><X size={14} /></button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
